// extracted by mini-css-extract-plugin
export default {"container":"UpdateOption_container__YvDnL"};